import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {SVGIcon} from '@homeaway/react-svg';
import {BEACH__24, BEACH__16, COMPASS__16, COMPASS__24, LIGHTBULB__16, LIGHTBULB__24} from '@homeaway/svg-defs';

import './DiscoveryButton.less';

const icons = {
    'VARIANT1__16': BEACH__16,
    'VARIANT1__24': BEACH__24,
    'VARIANT2__16': COMPASS__16,
    'VARIANT2__24': COMPASS__24,
    'VARIANT3__16': LIGHTBULB__16,
    'VARIANT3__24': LIGHTBULB__24
};


function DiscoveryButton({isWithNav, showDiscoveryBadge, discoveryBadgeLabel, discoveryLabel, discoveryVariant}) {
    const badgeCName = classNames('badge', {
        'badge--with-nav': isWithNav,
        'badge--with-tray': !isWithNav
    });
    const iconIndex = `VARIANT${discoveryVariant}__${isWithNav ? '24' : '16'}`;
    return (
        <div className={'DiscoveryButton site-header-nav__scratchpad'} data-bypass="true">
            <SVGIcon inlineFlex markup={icons[iconIndex]}/>
            <span className={'site-header-nav__icon-label'}>{discoveryLabel}</span>
            {showDiscoveryBadge && <div className={badgeCName}>{discoveryBadgeLabel}</div>}
        </div>
    );
}

DiscoveryButton.propTypes = {
    showDiscoveryBadge: PropTypes.bool,
    discoveryBadgeLabel: PropTypes.string,
    isWithNav: PropTypes.bool,
    discoveryLabel: PropTypes.string,
    discoveryVariant: PropTypes.oneOf([1, 2, 3])
};

export {DiscoveryButton};
